import React, { FC } from 'react';
import CancelIcon from '@material-ui/icons/Cancel';
import { IconButton, IconButtonProps, makeStyles } from '@material-ui/core';
import classNames from 'classnames';

interface Props extends IconButtonProps {
  onClick: () => void;
  lighter?: boolean;
}

const useStyles = makeStyles(theme => ({
  icon: {
    color: theme.palette.grey[400],
  },
}));

const RemoveIcon: FC<Props> = ({ onClick, lighter, classes }) => {
  const customClasses = useStyles();

  return (
    <IconButton
      onClick={onClick}
      className={classNames({ [customClasses.icon]: lighter })}
      classes={classes}
    >
      <CancelIcon />
    </IconButton>
  );
};

export default RemoveIcon;
